import React, { Component } from "react";
import { List, ListItem } from "material-ui/List";
import Checkbox from "material-ui/Checkbox";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import Paper from "material-ui/Paper";
import AppEvent from "./AppEvent";
import StatePreview from "./StatePreview";

class UiComp extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
    this.handleStateClick = this.handleStateClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  handleStateClick(event, state) {
    console.log("handleStateClick");
    this.props.onGoToState(state);
  }

  render() {
    var that = this;
    function findEventForId(eventId) {
      function findEvent(localType) {
        return localType.id === eventId;
      }
      let found = that.props.uievents.find(findEvent);
      console.log("findEventForId " + eventId + " found: " + found);
      return found;
    }
    function findStateForId(ids, index, state, forActions) {
      console.log("findStateForId");
      function findState(state) {
        return state.id === parseInt(ids[index]);
      }
      let found;
      let events = state.eventsOutput;
      if (events && events[0]) {
        let event = events[0];
        if (event.actions && forActions)
          //also for an action we might need to go through parent states first (which are attributes)
          found = event.actions.find(findState);
        else found = event.attributes.find(findState);
      }
      console.log("findStateForId " + ids[index] + " found: " + found);
      if (found) {
        if (found.state) {
          if (ids[index + 1])
            return (
              found.state.title +
              "." +
              findStateForId(ids, index + 1, found.state, forActions)
            );
          else return found.state.title;
        } else return found.name;
      } else return "";
    }
    let images;
    if (this.props.comp.images)
      images = this.props.comp.images.map(image => {
        return (
          <div
            style={{ maxHeight: 200, overflow: "hidden", position: "relative" }}
          >
            <img src={image} style={{ width: 140, height: "auto" }} />
          </div>
        );
      });
    else images = "";
    let details;
    if (!this.props.comp.spec) details = "";
    else {
      if (this.state.expanded) {
        let detailText;
        function findForStateAttrIdMatch(m, p1) {
          return (
            "`" +
            findStateForId(p1.split("."), 0, that.props.state, false) +
            "`"
          );
        }
        function findForStateActionIdMatch(m, p1) {
          return (
            "`" + findStateForId(p1.split("."), 0, that.props.state, true) + "`"
          );
        }
        function findForIdMatch(m, p1) {
          var found = findEventForId(parseInt(p1));
          var name;
          if (found) name = found.name;
          else name = "";
          return "`" + name + "`";
        }
        detailText = this.props.comp.spec;
        detailText = detailText.replace(
          /\*\*\*(\d+(\.\d+)*)\*\*\*/g,
          findForStateActionIdMatch
        );
        detailText = detailText.replace(
          /\*\*(\d+(\.\d+)*)\*\*/g,
          findForStateAttrIdMatch
        );
        detailText = detailText.replace(/\*(\d+)\*/g, findForIdMatch);

        let events;
        events = (
          <div>
            {this.props.comp.events.map(eventId => {
              let event = findEventForId(eventId);
              return <AppEvent eventPassed={event} />;
            })}
          </div>
        );
        details = (
          <p style={{ textAlign: "left", fontSize: 12, maxWidth: 240 }}>
            <ReactMarkdown source={detailText} />
            {events}
          </p>
        );
      } else {
        details = <span style={{ color: "#cccccc", fontSize: 12 }}>(+)</span>;
      }
    }
    let states;
    if (this.props.comp.states)
      states = (
        <div
          style={{
            margin: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "top",
            width: "fit-content"
          }}
        >
          {this.props.comp.states.map(uistate => {
            let thestate;
            if (uistate.type === "attribute")
              thestate = (
                <Paper
                  style={{ padding: 4, width: "100%", textAlign: "center" }}
                >
                  <div style={{ padding: 6, background: "#ccff00" }}>
                    <span style={{ fontSize: 14 }}>{uistate.title}</span>
                  </div>
                </Paper>
              );
            else if (uistate.type === "state")
              thestate = (
                <Paper
                  style={{ padding: 4, width: "100%", textAlign: "center" }}
                  onClick={e => {
                    e.stopPropagation();
                    that.handleStateClick(e, uistate);
                  }}
                >
                  <StatePreview
                    state={uistate}
                    uievents={that.props.uievents}
                  />
                </Paper>
              );
            else thestate = "";
            return <span style={{ margin: 2 }}>{thestate}</span>;
          })}
        </div>
      );
    else states = "";
    let children;
    if (this.props.comp.children)
      children = (
        <div
          style={{
            margin: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "top",
            width: "fit-content"
          }}
        >
          {this.props.comp.children.map(ui => {
            return (
              <UiComp
                comp={ui}
                uievents={that.props.uievents}
                globals={this.props.globals}
                state={that.props.state}
                onGoToState={that.props.onGoToState}
              />
            );
          })}
        </div>
      );
    else children = "";
    return (
      <Paper
        style={{
          width: "fit-content",
          minWidth: 200,
          marginBottom: 10,
          paddingLeft: 14,
          paddingRight: 14,
          paddingTop: 8,
          paddingBottom: 4,
          alignItems: "center"
        }}
        onClick={e => {
          e.stopPropagation();
          this.handleClick(e);
        }}
      >
        {this.props.comp.title}
        <div
          style={{
            margin: 2,
            padding: 0,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "top"
          }}
        >
          {images}
          &nbsp;&nbsp;&nbsp;&nbsp;
          <div>
            <div
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "top",
                width: "fit-content"
              }}
            >
              {states}
              {children}
            </div>
            {details}
          </div>
        </div>
      </Paper>
    );
  }
}

export default UiComp;



// WEBPACK FOOTER //
// ./src/components/UiComp.js